import Repository from "../Repository";

const getCategory = "get"
const addCategory = "create"
const editCategory = "update"
const deleteCategory = "delete"

const getSubCategory = "get"
const addSubCategory = "create"
const editSubCategory = "update"
const deleteSubCategory = "delete"

export default {
    getCategoryData(payload) {
        return Repository.post(transformRoute(getCategory), payload);
    },
    addCategoryData(payload) {
        return Repository.post(transformRoute(addCategory), payload);
    },
    editCategoryData(payload) {
        return Repository.post(transformRoute(editCategory), payload);
    },
    deleteCategoryData(payload) {
        return Repository.post(transformRoute(deleteCategory), payload);
    },

    // Subcategory
    getSubCategoryData(payload) {
        return Repository.post(transformRoute1(getSubCategory), payload);
    },
    addSubCategoryData(payload) {
        return Repository.post(transformRoute1(addSubCategory), payload);
    },
    editSubCategoryData(payload) {
        return Repository.post(transformRoute1(editSubCategory), payload);
    },
    deleteSubCategoryData(payload) {
        return Repository.post(transformRoute1(deleteSubCategory), payload);
    },

    
}
const transformRoute = (route) => {
  return `/baseAdminCategory/${route}`;
};
const transformRoute1 = (route) => {
  return `/baseAdminSubCategory/${route}`;
};